import { useCallback } from 'react';

import { motion } from 'motion/react';

import { colors } from '../../colors';

import * as css from './SwitchPill.css';

interface SwitchPillProps {
    handleClick: (value: string, index: number) => void;
    isActive: boolean;
    value: string;
    selectedKey: string;
    index: number;
    uniqueId?: string;
}

export function SwitchPill({ value, selectedKey, index, isActive, uniqueId, handleClick }: SwitchPillProps) {
    const onClick = useCallback(() => {
        handleClick(selectedKey, index);
    }, [handleClick, selectedKey, index]);

    return (
        <motion.button type="button" className={css.button} onClick={onClick}>
            <span
                className={css.value}
                style={{
                    color: isActive ? colors.blue[500] : colors.bluegray[600],
                }}
            >
                {value}
            </span>
            {isActive && (
                <motion.span
                    className={css.activeBackground}
                    layoutId={`activeBackground${uniqueId ?? ''}`}
                    transition={{ duration: 0.2, ease: 'circOut' }}
                >
                    {value}
                </motion.span>
            )}
        </motion.button>
    );
}
